var _style, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceThree(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 658 646",
    style: {
      enableBackground: "new 0 0 658 646"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:url(#SVGID_1_);stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{display:none;fill:none;stroke:url(#SVGID_3_);stroke-width:2;stroke-miterlimit:10;}\n\t.st3{display:none;fill:url(#SVGID_4_);}\n\t.st4{display:none;fill:url(#SVGID_5_);stroke:url(#SVGID_6_);stroke-width:2;stroke-miterlimit:10;}\n\t.st5{display:none;fill:url(#SVGID_7_);}\n\t.st6{display:none;}\n\t.st7{display:inline;fill:url(#SVGID_8_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 658,
    y1: 323,
    x2: 12,
    y2: 323
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3D2FF"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 335,
    cy: 323,
    r: 322
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 221.5,
    x2: 61,
    y2: 221.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCE0F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07831031,
    style: {
      stopColor: "#D0DEEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2085,
    style: {
      stopColor: "#DBD8D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3735,
    style: {
      stopColor: "#EDCFA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5158,
    style: {
      stopColor: "#FFC67F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#818CF7"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 30.5,
    cy: 221.5,
    r: 30.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 559,
    y1: 323.5,
    x2: 112,
    y2: 323.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3D2FF"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 335.5,
    cy: 323.5,
    r: 222.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 115,
    y1: 422.5,
    x2: 156,
    y2: 422.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCE0F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0614168,
    style: {
      stopColor: "#C3DEF5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1635,
    style: {
      stopColor: "#A9DAF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    style: {
      stopColor: "#80D3FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3544,
    style: {
      stopColor: "#6ACFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFAAE7"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 135.5,
    cy: 422.5,
    r: 20.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 335.5,
    cy: 323.5,
    r: 132.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0FA1FF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1126,
    style: {
      stopColor: "#44B6FF",
      stopOpacity: 0.5437
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2319,
    style: {
      stopColor: "#75C9FF",
      stopOpacity: 0.484
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3546,
    style: {
      stopColor: "#A0DAFF",
      stopOpacity: 0.4227
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4782,
    style: {
      stopColor: "#C2E7FF",
      stopOpacity: 0.3609
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6034,
    style: {
      stopColor: "#DDF2FF",
      stopOpacity: 0.2983
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#F0F9FF",
      stopOpacity: 0.2347
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8611,
    style: {
      stopColor: "#FBFEFF",
      stopOpacity: 0.1695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 469,
    y1: 323.5,
    x2: 202,
    y2: 323.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3D2FF"
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 335.5,
    cy: 323.5,
    r: 132.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 189,
    y1: 305,
    x2: 219,
    y2: 305
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCE0F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09020741,
    style: {
      stopColor: "#C3DEF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2402,
    style: {
      stopColor: "#A9DAEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4302,
    style: {
      stopColor: "#80D2EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5674,
    style: {
      stopColor: "#5ECCE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8652,
    style: {
      stopColor: "#77B4E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#818CF7"
    }
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 204,
    cy: 305,
    r: 15
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 305,
    y1: 323.5,
    x2: 366,
    y2: 323.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3F81FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4901,
    style: {
      stopColor: "#A47ED3",
      stopOpacity: 0.5099
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8373,
    style: {
      stopColor: "#E67CB7",
      stopOpacity: 0.1627
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7BAC",
      stopOpacity: 0
    }
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 335.5,
    cy: 323.5,
    r: 30.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceThree);
export default __webpack_public_path__ + "static/media/space-three.269d9ae8bad0e445f1b1f19b80e185fa.svg";
export { ForwardRef as ReactComponent };